export default __webpack_public_path__ + "static/media/loading.465e1f00.svg";